import { CalendarComponent } from '@modules/calendar/pages/calendar/calendar.component';
import { CalendarResolver } from '@modules/calendar/pages/resolvers/calendar.resolver';
import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';

export const CalendarRoutes: CustomRoutes = [
  {
    path: '',
    component: CalendarComponent,
    children: [],
    resolve: [CalendarResolver],
    name: 'calendar',
    data: {
      metaTitle: 'Calendar.calendar',
      notRestorationPosition: true,
    },
  },
];
